import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import DataTable from '../../components/Table/DataTable';
import SearchBox from '../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { CircularProgress } from '@material-ui/core';

import { getBadgeWinners } from '../../services/badges';

const BadgeWinners = props => {
  const dispatch = useDispatch();
  const params = useParams();

  const [winners, setWinners] = useState([]);
  const [actualPage, setActualPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [pageTitle, setPageTitle] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState({
    searchItem: '',
    search: '',
  });
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    const page = params.page || actualPage;
    displayWinners(page);
  }, []);

  const displayWinners = async page => {
    try {
      const badgeId = props.match.params.uid;
      if (!page) page = actualPage;
      setIsLoading(true);
      const { data } = await getBadgeWinners(badgeId, page);
      setWinners(data.rows);
      setPageTitle('Badge Winners');
      setTotalItems(data.count);
      setTotalPages(data.pages);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const headers = ['channelId', 'badgeId', 'challengeId', 'Channel.uid'];
  const SearchBoxHeaders = ['channelId', 'badgeId', 'challengeId'];

  const handleSubmitSearch = searchBox => {
    setSearch(searchBox);
    setIsSearching(true);
    displayWinners(0, searchBox);
  };

  const handleChangePage = async page => {
    setActualPage(page);
    displayWinners(page);
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>
          {pageTitle} ({totalItems})
        </h1>
        <SearchBox selectItems={SearchBoxHeaders} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} onKeyDown={escape} />
      </div>

      <DataTable
        head={headers}
        body={winners}
        bodyColumn={headers}
        action={true}
        linkPath={'channels'}
        totalPages={totalPages}
        currentPage={actualPage}
        setPageChange={handleChangePage}
        isNotOrdenable
      />
    </>
  );
};

export default BadgeWinners;
